/* ── Countdown ────────────────────────────────────────────────────── */
window.lunaCountdown = function(elementId, hours) {
  const el = document.getElementById(elementId);
  if (!el) return;
  let s = (hours || 5) * 3600;
  function tick() {
    const h = String(Math.floor(s / 3600)).padStart(2, '0');
    const m = String(Math.floor(s % 3600 / 60)).padStart(2, '0');
    const sec = String(s % 60).padStart(2, '0');
    el.textContent = h + ':' + m + ':' + sec;
    if (s > 0) s--;
  }
  tick();
  setInterval(tick, 1000);
};

/* ── Nav scroll shadow ───────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function () {
  const nav = document.getElementById('lunaNav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('up', window.scrollY > 8);
    }, { passive: true });
  }

  /* ── Reveal on scroll ──────────────────────────────────────────── */
  const obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.rv').forEach(function (el) { obs.observe(el); });

  /* ── Gallery slider ────────────────────────────────────────────── */
  var gIdx = 0;
  function gSlides() { return document.querySelectorAll('.gal-slide'); }
  function gThumbs() { return document.querySelectorAll('.gal-t'); }
  function gDots() { return document.querySelectorAll('.gal-dot'); }

  window.gGoto = function (i) {
    var sl = gSlides(), th = gThumbs(), dots = gDots();
    sl.forEach(function (s) { s.classList.remove('on'); });
    th.forEach(function (t) { t.classList.remove('on'); });
    dots.forEach(function (d) { d.classList.remove('on'); });
    gIdx = ((i % sl.length) + sl.length) % sl.length;
    if (sl[gIdx]) sl[gIdx].classList.add('on');
    if (th[gIdx]) th[gIdx].classList.add('on');
    if (dots[gIdx]) dots[gIdx].classList.add('on');
  };
  window.gMove = function (dir) { window.gGoto(gIdx + dir); };

  // Build dots
  var dotsContainer = document.getElementById('gDots');
  if (dotsContainer) {
    var slides = gSlides();
    dotsContainer.innerHTML = Array.from(slides).map(function (_, i) {
      return '<button class="gal-dot' + (i === 0 ? ' on' : '') + '" onclick="gGoto(' + i + ')" aria-label="Image ' + (i + 1) + '"></button>';
    }).join('');
  }
  if (gSlides().length > 1) setInterval(function () { window.gMove(1); }, 4000);

  /* ── Tier selector ─────────────────────────────────────────────── */
  window.pickT = function (t) {
    document.querySelectorAll('.tier').forEach(function (x) { x.classList.remove('on'); });
    t.classList.add('on');
  };

  /* ── Purchase mode toggle ──────────────────────────────────────── */
  window.pMode = function (b) {
    document.querySelectorAll('.p-btn').forEach(function (x) { x.classList.remove('on'); });
    b.classList.add('on');
  };

  /* ── Hero accordion (product page) ────────────────────────────── */
  window.accT = function (b) {
    var item = b.closest('.acc-item');
    var wasOpen = item.classList.contains('op');
    document.querySelectorAll('.acc-item').forEach(function (x) { x.classList.remove('op'); });
    if (!wasOpen) item.classList.add('op');
  };

  /* ── FAQ accordion ─────────────────────────────────────────────── */
  window.fqT = function (b) {
    var item = b.closest('.faq-item');
    var wasOpen = item.classList.contains('op');
    document.querySelectorAll('.faq-item').forEach(function (x) { x.classList.remove('op'); });
    if (!wasOpen) item.classList.add('op');
  };

  /* ── Before/After sliders ──────────────────────────────────────── */
  window.makeBA = function (sId, bId, lId) {
    var s = document.getElementById(sId);
    var b = document.getElementById(bId);
    var l = document.getElementById(lId);
    if (!s || !b || !l) return;
    var dragging = false;
    function mv(x) {
      var r = s.getBoundingClientRect();
      var p = Math.min(Math.max((x - r.left) / r.width, 0.03), 0.97);
      b.style.clipPath = 'inset(0 ' + ((1 - p) * 100) + '% 0 0)';
      l.style.left = (p * 100) + '%';
    }
    s.addEventListener('mousedown', function (e) { dragging = true; mv(e.clientX); });
    s.addEventListener('touchstart', function (e) { dragging = true; mv(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('mousemove', function (e) { if (dragging) mv(e.clientX); }, { passive: true });
    window.addEventListener('touchmove', function (e) { if (dragging) mv(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('mouseup', function () { dragging = false; });
    window.addEventListener('touchend', function () { dragging = false; });
  };

  /* ── Science cards animate ─────────────────────────────────────── */
  var sciObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('sci-active'); sciObs.unobserve(e.target); }
    });
  }, { threshold: 0.3 });
  document.querySelectorAll('.how-card').forEach(function (c) { sciObs.observe(c); });

  /* ── Top Reviews Carousel ──────────────────────────────────────── */
  var trIdx = 0;
  window.trGoto = function (i) {
    var track = document.getElementById('trTrack');
    if (!track) return;
    var dots = document.querySelectorAll('.top-rev-dot');
    var cards = track.querySelectorAll('.top-rev-card');
    trIdx = ((i % cards.length) + cards.length) % cards.length;
    track.style.transform = 'translateX(-' + trIdx * 100 + '%)';
    dots.forEach(function (d, j) { d.classList.toggle('on', j === trIdx); });
  };
  window.trMove = function (dir) { window.trGoto(trIdx + dir); };
  setInterval(function () { window.trMove(1); }, 5000);

  /* ── Inventory bar counter ─────────────────────────────────────── */
  var invEl = document.getElementById('invCount');
  if (invEl) {
    var n = Math.floor(Math.random() * 18) + 15;
    invEl.textContent = n;
    setInterval(function () {
      n = Math.min(Math.max(n + (Math.random() < 0.6 ? 1 : -1), 10), 42);
      invEl.textContent = n;
    }, 4800 + Math.random() * 3000);
  }

  /* ── Reviews marquee builder ───────────────────────────────────── */
  window.buildRevs = function (id, items) {
    var t = document.getElementById(id);
    if (!t) return;
    var doubled = items.concat(items);
    t.innerHTML = doubled.map(function (r) {
      return '<div class="rev-card">' +
        '<div class="rev-card-img"><img src="' + r.img + '" alt="' + r.n + '" loading="lazy" onerror="this.parentNode.innerHTML=\'<div class=rev-card-img-ph>Photo UGC</div>\'"/></div>' +
        '<div class="rev-card-body">' +
        '<div class="rev-card-stars">★★★★★</div>' +
        '<div class="rev-card-top">' +
        '<div class="rev-av"><img src="' + r.av + '" alt="' + r.n + '" loading="lazy"/></div>' +
        '<div><div class="rev-name">' + r.n + '</div><div class="rev-meta">' + r.a + '</div></div>' +
        '<div class="rev-vbd">✓ Vérifiée</div></div>' +
        '<p class="rev-text">"' + r.q + '"</p>' +
        '<div class="rev-card-foot"><svg viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>Achat vérifié · Masque Lunavitta</div>' +
        '</div></div>';
    }).join('');
  };

  /* ── Scratch card ──────────────────────────────────────────────── */
  var scratchShown = false;
  window.showScratch = function () {
    if (scratchShown) return;
    scratchShown = true;
    var ov = document.getElementById('scratchOverlay');
    if (!ov) return;
    ov.classList.add('on');
    initScratch();
  };
  window.closeScratch = function () {
    var ov = document.getElementById('scratchOverlay');
    if (ov) ov.classList.remove('on');
  };
  window.applyScratchCode = function () {
    window.closeScratch();
    var t = document.createElement('div');
    t.className = 'sc-toast';
    t.textContent = '✓ Réduction activée sur votre commande !';
    document.body.appendChild(t);
    setTimeout(function () { t.classList.add('in'); }, 50);
    setTimeout(function () { t.classList.remove('in'); setTimeout(function () { t.remove(); }, 400); }, 3500);
  };

  function initScratch() {
    var cv = document.getElementById('scratchCanvas');
    if (!cv) return;
    var ctx = cv.getContext('2d');
    var g = ctx.createLinearGradient(0, 0, cv.width, cv.height);
    g.addColorStop(0, '#c8006a'); g.addColorStop(1, '#ff6bb5');
    ctx.fillStyle = g; ctx.fillRect(0, 0, cv.width, cv.height);
    ctx.fillStyle = 'rgba(255,255,255,.08)';
    for (var i = 0; i < 200; i++) { ctx.beginPath(); ctx.arc(Math.random() * cv.width, Math.random() * cv.height, Math.random() * 3, 0, Math.PI * 2); ctx.fill(); }
    ctx.fillStyle = 'rgba(255,255,255,.9)';
    ctx.font = 'bold 14px Inter,sans-serif'; ctx.textAlign = 'center';
    ctx.fillText('✦ Grattez ici ✦', cv.width / 2, cv.height / 2 - 8);
    ctx.font = '11px Inter,sans-serif'; ctx.fillStyle = 'rgba(255,255,255,.6)';
    ctx.fillText('Votre surprise vous attend', cv.width / 2, cv.height / 2 + 14);
    ctx.globalCompositeOperation = 'destination-out';
    var scratching = false;
    function scratch(x, y) {
      ctx.beginPath(); ctx.arc(x, y, 55, 0, Math.PI * 2); ctx.fill();
      var d = ctx.getImageData(0, 0, cv.width, cv.height).data;
      var c = 0; for (var j = 3; j < d.length; j += 4) if (d[j] < 128) c++;
      if (c / (cv.width * cv.height) > 0.12) {
        var cta = document.getElementById('scratchCta');
        if (cta && cta.style.display === 'none') { ctx.clearRect(0, 0, cv.width, cv.height); cta.style.display = 'flex'; }
      }
    }
    cv.addEventListener('mousedown', function (e) { scratching = true; var r = cv.getBoundingClientRect(); scratch(e.clientX - r.left, e.clientY - r.top); });
    window.addEventListener('mousemove', function (e) { if (!scratching) return; var r = cv.getBoundingClientRect(); scratch(e.clientX - r.left, e.clientY - r.top); });
    window.addEventListener('mouseup', function () { scratching = false; });
    cv.addEventListener('touchstart', function (e) { e.preventDefault(); var r = cv.getBoundingClientRect(), t = e.touches[0]; scratch(t.clientX - r.left, t.clientY - r.top); }, { passive: false });
    cv.addEventListener('touchmove', function (e) { e.preventDefault(); var r = cv.getBoundingClientRect(), t = e.touches[0]; scratch(t.clientX - r.left, t.clientY - r.top); }, { passive: false });
  }

  setTimeout(window.showScratch, 40000);
  document.addEventListener('mouseleave', function (e) { if (e.clientY < 5) window.showScratch(); });
});
